import { useState } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftCircleLeftFill } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";
import { ReactComponent as ArrowRightCircleLeftFill } from "bootstrap-icons/icons/arrow-right-circle-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { usePermissionsList } from "../../hooks/usePermissions";

const PermissionList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [permissionsPerPage] = useState(12);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const navigate = useNavigate();
  const { data: permissions = [], isLoading: loading } = usePermissionsList();

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };


  // Format text (handles dots and underscores)
  const formatPermissionText = (text) => {
    if (!text) return "";
    return text
      .replace(/[_\.]/g, " ") // replace underscores & dots with spaces
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word
  };


  // Parse permission name (supports 2-part or 3-part)
  const parsePermission = (permission) => {
    const parts = permission.split(".");
    const action = parts.pop(); // last part is action
    const resource = parts.join("."); // rest is resource
    return { resource, action };
  };

  // Filtered list
  const filteredPermissions = permissions.filter((item) =>
    item.name.toLowerCase().includes(filterText.toLowerCase().trim())
  );

  // Pagination logic
  const indexOfLastPermission = currentPage * permissionsPerPage;
  const indexOfFirstPermission = indexOfLastPermission - permissionsPerPage;
  const currentPermissions = filteredPermissions.slice(
    indexOfFirstPermission,
    indexOfLastPermission
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const hasNextPage = () => indexOfLastPermission < filteredPermissions.length;
  const hasPrevPage = () => currentPage > 1;

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section
            className="w-full pl-[3%] pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 text-darkGreen3 pr-2">
                    Permission
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>

          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap items-center justify-between gap-4">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>
          </div>

          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <section className="text-gray-600 body-font">
              <div className="container px-1 py-2 mx-auto">
                <div className="flex flex-wrap -m-2">
                  {currentPermissions.length > 0 ? (
                    currentPermissions.map((permission, index) => {
                      const { resource, action } = parsePermission(permission.name);

                      return (
                        <div
                          key={index}
                          className="p-2 lg:w-1/3 md:w-1/2 w-full"
                        >
                          <div className="h-full flex items-center border-darkGreen3 border p-1.5 rounded-lg">
                            <div className="flex-grow">
                              <h2 className="flex items-center justify-between text-darkGreen3 title-font font-medium capitalize">
                                <span>{formatPermissionText(action)}</span>
                              </h2>

                              <p className="text-gray-500 flex items-center">
                                Permission for:
                                <span className="ml-2 text-dash5">
                                  {formatPermissionText(resource)}
                                </span>
                              </p>
                              {/* need to comment thius out later  */}
                              {/* <p className="text-sm text-gray-400 mt-1">
                                Full Permission:{" "}
                                <span className="text-gray-600">{permission.name}</span>
                              </p> */}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="w-full text-center">
                      No permissions found
                    </div>
                  )}
                </div>

                <div className="flex justify-end mt-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination flex mx-auto">
                      <li className={`page-item ${!hasPrevPage() ? "disabled" : ""}`}>
                        <button
                          className="text-dGrey3 bg-black2 hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center inline-flex items-center gap-1 m-2"
                          onClick={() => paginate(currentPage - 1)}
                          disabled={!hasPrevPage()}
                        >
                          <span className="flex mx-2 mt-1">
                            <ArrowLeftCircleLeftFill className="w-5 h-5 mr-2" />
                            Prev
                          </span>
                        </button>
                      </li>
                      <li className={`page-item ${!hasNextPage() ? "disabled" : ""}`}>
                        <button
                          className="text-dGrey3 bg-black2 hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center inline-flex items-center gap-1 m-2"
                          onClick={() => paginate(currentPage + 1)}
                          disabled={!hasNextPage()}
                        >
                          <span className="flex mx-2 mt-1">
                            <ArrowRightCircleLeftFill className="w-5 h-5 mr-2" />
                            Next
                          </span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </section>
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default PermissionList;
